import React, { useCallback, useRef } from 'react';
import { PeersonaHandoffInfo } from '../../hooks/api/usePeersonaChat';
import { useAssistantWidget } from '../../contexts/assistant-widget-context';
import { useFi } from '../../contexts/fi-context';
import { PEERSONA_REFERRAL_ACCENT } from './peersona-styles';

interface Props {
  handoff: PeersonaHandoffInfo;
}

const CTA_LABEL_BY_SUBTYPE: Record<string, string> = {
  connect_listener: 'Continue in Fi',
  schedule_call: 'Schedule in Fi',
  find_content: 'Search in Fi',
  default: 'Continue in Fi',
};

/**
 * Soft handoff affordance under Blake's concierge ack. The bubble already
 * explains that Fi handles this; we offer a single optional button — no
 * auto-switch, no countdown, no card chrome that reads like a modal.
 */
export const PeersonaHandoffCard: React.FC<Props> = ({ handoff }) => {
  const { switchContext } = useAssistantWidget();
  const { setInputDraft, openPanel: openFiPanel } = useFi();
  const hasExecutedRef = useRef(false);

  const executeHandoff = useCallback(() => {
    if (hasExecutedRef.current) return;
    hasExecutedRef.current = true;
    setInputDraft(handoff.original_message);
    switchContext({ kind: 'fi' });
    openFiPanel();
  }, [handoff.original_message, setInputDraft, switchContext, openFiPanel]);

  const ctaLabel = CTA_LABEL_BY_SUBTYPE[handoff.subtype] ?? CTA_LABEL_BY_SUBTYPE.default;

  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={executeHandoff}
        className="font-albert-sans inline-flex items-center justify-center rounded-full border px-4 py-1.5 text-xs font-semibold transition-colors hover:bg-gray-50"
        style={{
          borderColor: PEERSONA_REFERRAL_ACCENT,
          color: PEERSONA_REFERRAL_ACCENT,
        }}
      >
        {ctaLabel}
      </button>
    </div>
  );
};
